import { useLabels, useMapCore, useMapStore } from "../hooks";
import { Icon } from "../icons";
import { Button } from "../primitives/Button";

export type HintStripProps = { className?: string };

export function HintStrip({ className }: HintStripProps) {
  const core = useMapCore();
  const labels = useLabels();
  const hint = useMapStore(a => a.hint);

  if (hint === null) return null;

  return (
    <div className={["fxmap-hint", "fxmap-card", className ?? ""].filter(Boolean).join(" ")} role="status" aria-live="polite" data-fxmap="hint-strip">
      <Icon name="info" className="fxmap-hint-icon" />
      <span className="fxmap-hint-text">{hint.text}</span>
      <Button kind="text" size="sm" label={labels.hintOk} className="fxmap-hint-ok" action="hint-ok" onClick={() => core.markHintSeen(hint.id)} />
    </div>
  );
}
